import React, { Component } from 'react'
import ModalContext from './context'

interface ModalProviderProps {
    children?: React.ReactNode;
}

class ModalProvider extends Component<ModalProviderProps> {
    showModal = (component: any, props = {}) => {
        this.setState({
            component,
            props
        });
    };

    hideModal = () => this.setState({
        component: null,
        props: {},
    });

    state = {
        component: null,
        props: {},
        showModal: this.showModal,
        hideModal: this.hideModal
    };

    render() {
        return (
            <ModalContext.Provider value={this.state}>
                {this.props.children}
            </ModalContext.Provider>
        );
    }
}

export default ModalProvider